<template>
  <modal
    :show="show"
    header-classes="justify-content-center center"
    modal-classes="modal-lg"
    @close="handleClose()"
  >
    <h4 slot="header">
      Vacation Dates
    </h4>

    <collapse
      :active-index="activeForm"
      ref="childCollapseComponent"
    >
      <collapseItem
        title="Create new vacation date"
        class="bold-collapse-title"
        :show-caret="false"
      >
        <NewForm
          class="new-form"
          ref="childVDFormComponent"
          @close="handleClose()"
        />
      </collapseItem>
    </collapse>

    <div id="future-dates-table" v-if="vacationDates">
      <table class="table">
        <thead>
          <tr>
            <th>Break name</th>
            <th>Dates</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(vacationDate, index) in futureVacationDates"
            :key="vacationDate.id"
          >
            <td
              :class="{
                hide: editVD.id == vacationDate.id
              }"
            >
              {{ vacationDate.name }}
            </td>
            <td
              :class="{
                hide: editVD.id != vacationDate.id,
                validationError: nameError,
                noError: !nameError
              }"
              style="padding:0 2px;"
            >
              <el-input
                type="text"
                placeholder="Break name"
                v-model="editVD.name"
              />
              <p
                v-show="nameError"
                :class="{
                  validationErrorText: nameError
                }"
              >
                {{ nameError }}
              </p>
            </td>
            <td
              :class="{
                hide: editVD.id == vacationDate.id
              }"
            >
              {{ vacationDate.range_readable }}
            </td>
            <td
              :class="{
                hide: editVD.id != vacationDate.id
              }"
              style="padding:0 2px;"
            >
              <datepicker
                class="datepicker"
                placeholder="Select Date"
                v-model="editVD.startDate"
                :disabled-dates="{
                  to: new Date()
                }"
              />
              <datepicker
                class="datepicker"
                placeholder="Select Date"
                v-model="editVD.endDate"
                :disabled-dates="invalidDates"
              />
            </td>
            <td
              :class="{
                hide: editVD.id == vacationDate.id
              }"
            >
              <i
                class="el-icon-edit icon-btn"
                @click="handleEdit(index)"
              />
            </td>
            <td
              :class="{
                hide: editVD.id != vacationDate.id
              }"
            >
              <i
                class="el-icon-check icon-btn"
                @click="validateInput()"
              />
            </td>
            <td
              :class="{
                hide: editVD.id == vacationDate.id
              }"
            >
              <i
                class="el-icon-delete icon-btn"
                @click="validateDelete = true; deleteVD = vacationDate.id"
              />
            </td>
            <td
              :class="{
                hide: editVD.id != vacationDate.id
              }"
            >
              <i
                class="el-icon-close icon-btn"
                @click="editVD.id = null"
              />
            </td>
          </tr>
          <tr
            v-for="vacationDate in pastVacationDates"
            :key="vacationDate.id"
          >
            <td>{{ vacationDate.name }}</td>
            <td>{{ vacationDate.range_readable }}</td>
            <td />
            <td />
          </tr>
        </tbody>
      </table>
      <modal
        :show="validateDelete"
        :show-header="false"
        header-classes="justify-content-center center"
      >
        <p>Are you sure you want to delete this vacation date?</p>
        <div>
          <p-button style="float: right" @click="closeDelete()">
            Cancel
          </p-button>
          <p-button style="float: right" class="custom-modal-type" @click="handleDelete()">
            Yes
          </p-button>
        </div>
      </modal>
    </div>
  </modal>
</template>

<script>
import {
    mapState, mapGetters
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import modal from '../UIComponents/Modal';
import NewForm from './Form.vue';
import collapse from '../UIComponents/Collapse/Collapse';
import collapseItem from '../UIComponents/Collapse/CollapseItem';

export default {
    name: 'VacationDatesModal',
    components: {
        modal,
        NewForm,
        Datepicker,
        collapse,
        collapseItem
    },
    data() {
        return {
            namespace: 'VacationDates',
            editVD: {
                id: null,
                name: null,
                startDate: null,
                endDate: null
            },
            nameError: null,
            invalidDates: {
                to: new Date()
            },
            deleteVD: null,
            validateDelete: false
        };
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        activeForm: {
            type: Number,
            default: -1,
        }
    },
    computed: {
        ...mapState({
            error: (state) => state.VacationDates.error,
        }),
        ...mapGetters({
            vacationDates: 'VacationDates/vacationDates',
            futureVacationDates: 'VacationDates/futureVacationDates',
            pastVacationDates: 'VacationDates/pastVacationDates'
        }),
    },
    watch: {
        'editVD.id': function check() {
            if (this.editVD.startDate) {
                if (!this.editVD.endDate || this.editVD.endDate <= this.editVD.startDate) {
                    this.editVD.endDate = null;
                }
                this.invalidDates = {
                    to: new Date(this.editVD.startDate)
                };
            } else {
                this.invalidDates = {
                    to: new Date()
                };
            }
        },
        'editVD.startDate': function check() {
            if (this.editVD.startDate) {
                if (!this.editVD.endDate || this.editVD.endDate <= this.editVD.startDate) {
                    this.editVD.endDate = null;
                }
                if (this.editVD.startDate >= Date.now()) {
                    this.invalidDates = {
                        to: new Date(this.editVD.startDate)
                    };
                }
            } else {
                this.invalidDates = {
                    to: new Date()
                };
            }
        },
    },
    methods: {
        getVDFromIndex(index) {
            return this.futureVacationDates[index];
        },
        handleEdit(index) {
            if (index == null) {
                this.clearInputs();
            } else {
                const editThis = this.getVDFromIndex(index);
                this.editVD.id = editThis.id;
                this.editVD.name = editThis.name;
                this.editVD.startDate = new Date(editThis.start_date);
                this.editVD.endDate = new Date(editThis.end_date);
                this.nameError = null;
            }
        },
        validateInput() {
            switch (this.editVD.name === '') {
            case true:
                this.nameError = 'Please enter a name.';
                break;
            default:
                this.nameError = null;
            }
            switch (!this.nameError) {
            case true:
                this.handleSave();
                break;
            default:
                break;
            }
        },
        handleSave() {
            const vacationData = {
                id: this.editVD.id,
                name: this.editVD.name,
                start_date: this.transformJSDateForPayload(this.editVD.startDate),
                end_date: this.transformJSDateForPayload(this.editVD.endDate),
            };
            this.$store.dispatch(`${this.namespace}/updateVacationDate`, {
                vacation_date: vacationData
            }).then(
                this.clearInputs()
            );
        },
        handleDelete() {
            this.$store.dispatch(`${this.namespace}/deleteVacationDate`,
                { id: this.deleteVD }).then(this.closeDelete());
        },
        closeDelete() {
            this.validateDelete = false;
            this.deleteVD = null;
        },
        clearInputs() {
            this.editVD.id = null;
            this.editVD.name = null;
            this.editVD.startDate = null;
            this.editVD.endDate = null;
            this.invalidDates = {
                to: new Date()
            };
            this.nameError = null;
        },
        handleClose() {
            this.$refs.childVDFormComponent.clearInputs();
            this.$refs.childCollapseComponent.deactivateAll();
            this.clearInputs();
            this.$emit('close');
        },
    },
};
</script>
<style>
/* Match collapse title to table headers */
.bold-collapse-title .card-header a[data-toggle="collapse"] {
  text-align: left;
  text-transform: uppercase;
  font-weight: 700;
  color: #000 !important;
}
/* Prevent page jumping on disappearing scrollbars for modals */
.modal {
  overflow-x: hidden;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
.modal::-webkit-scrollbar {
  width: 0 !important;
}
</style>

<style scoped>
.new-form {
    margin-bottom: 50px;
}
.hide {
  display: none;
}
.table > tbody > tr > td {
  width: 50%;
}
.datepicker {
  width: 50%;
  display: inline-block;
}
</style>
